export default {
  empty: { icon: './img/empty.png', description: '0개 ~ 1개' },
  few: { icon: './img/few.png', description: '30개 미만' },
  some: { icon: './img/some.png', description: '100개 미만' },
  plenty: { icon: './img/plenty.png', description: '100개 이상' }
};
